Symbol.toStringTag;
const _CancellablePromise = class _CancellablePromise {
  constructor(promise, isCancelled = false) {
    this._promise = promise;
    this._isCanceled = isCancelled;
  }
  then(onfulfilled, onrejected) {
    return new _CancellablePromise(this._promise.then(onfulfilled, onrejected), this._isCanceled);
  }
  catch(onrejected) {
    return new _CancellablePromise(this._promise.catch(onrejected), this._isCanceled);
  }
  finally(onfinally) {
    return new _CancellablePromise(this._promise.finally(onfinally), this._isCanceled);
  }
  static of(promise) {
    return new _CancellablePromise(promise);
  }
  cancel() {
    this._isCanceled = true;
    return this;
  }
  isCancelled() {
    return this._isCanceled;
  }
};
let CancellablePromise = _CancellablePromise;
export default CancellablePromise;
